import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { PublicHomeComponent } from "./modules/public-home/components/public-home/public-home.component";
import { LandingRedirectGuard } from './guards/landing-redirect.guard';

const routerOptions: any = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 120],
  onSameUrlNavigation: 'reload',
  relativeLinkResolution: 'legacy',
  useHash: true
};

const routes: Routes = [
  // {
  //   path:'',
  //   redirectTo:'karmayogi',
  //   pathMatch: 'full'
  // },
  {
    path: '',
    component: PublicHomeComponent,
    canActivate: [LandingRedirectGuard],
    pathMatch: 'full'
  },
  {
    path: 'aboutus',
    loadChildren: () => import('../app/modules/about-us/about-us.module').then(m => m.AboutUsModule),
  },
  {
    path: 'tenders',
    loadChildren: () => import('../app/modules/tenders/tenders.module').then(m => m.TendersModule),
  },
  {
    path: 'notifications',
    loadChildren: () => import('../app/modules/notifications/notifications.module').then(m => m.NotificationsModule),
  },

  {
    path: 'rti',
    loadChildren: () => import('./modules/rti-module/rti.module').then(m => m.RtiModule),
  },
  // {
  //   path: 'railway',
  //   loadChildren :()=> import('../app/modules/railway/railway.module').then(m=>m.RailwayModule),
  // },{
  //   path: 'post',
  //   loadChildren :()=> import('../app/modules/postal/postal.module').then(m=>m.PostalModule),
  // },
  {
    path: 'contentList',
    loadChildren: () => import('../app/modules/contentList/content-list.module').then(m => m.ContentListModule),
  },
  {
    path: 'show-all',
    loadChildren: () => import('../app/modules/show-all/show-all.module').then(m => m.ShowAllModule),
  },
  {
    path: 'mdoList',
    loadChildren: () => import('../app/modules/mdoUserList/mdo-user-list.module').then(m => m.MdoUserListModule),
  },
  {
    path: 'career',
    loadChildren: () => import('./modules/career/careerpage.module').then(m => m.CareerpageModule),
  },
  {
    path: 'contactus',
    loadChildren: () => import('./modules/contact-us/contact-us.module').then(m => m.ContactUsModule),
  },
  {
    path: 'helpcenter',
    loadChildren: () => import('./modules/help-center/help-center.module').then(m => m.HelpCenterModule),
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./modules/public-maintenance/public-maintenance.module').then(m => m.PublicMaintenanceModule),
  },

  {
    path: 'karmayogi-saptah',
    loadChildren: () => import('./modules/nlw/karmayogi-saptah/karmayogi-saptah.module').then(m => m.KarmayogiSaptahModule),
  },
  {
    path: 'sadhana-saptah',
    loadChildren: () => import('./modules/nlw/sadhana-saptah/sadhana-saptah.module').then(m => m.SadhanaSaptahModule),
  },
  {
    path: 'campaign',
    loadChildren: () => import('./modules/campaign/campaign.module').then(m => m.CampaignModule),
  },
  // {
  //   path: 'karmayogi',
  //   loadChildren :()=> import('../app/modules/public-home/public-home.module').then(m=>m.PublicHomeModule),
  // }
  {
    path: 'partner-with-us',
    loadChildren: () => import('../app/modules/partner-with-us/partner-with-us.module').then(m => m.PartnerWithUsModule),
  },
  // Unknown URLs (or routes missing from an older cached build) would otherwise fail
  // navigation and leave a blank page; send them to the home page instead
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
